import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { ItemType } from "sprout-graphql";
import { Button } from "sprout-ui-dom/dist/Button";
import { Text, Flex } from "sprout-ui-primitives";
import { media } from "sprout-ui-theme";
import tinytime from "tinytime";
import styled, { css } from "styled-components";
import { useSetItemsArchived, useSetItemsDeleted } from "@sprout/client-graphql";
import { usePostPage } from "./PostPageContext";
const PageBannerWrapper = styled(Flex)`
  flex-direction: column;
  align-items: center;

  padding: 16px;
  border-radius: 30px;

  margin-left: 16px;
  margin-right: 16px;

  ${media.up("medium", "pointer")} {
    margin-left: 0;
    margin-right: 0;
  }

  > :not(style) + :not(style) {
    margin-top: 8px;
  }

  ${({ $negativeMargins  })=>$negativeMargins && css`
      margin-bottom: 24px;

      ${media.up("medium", "pointer")} {
        margin-bottom: -48px !important;
        padding-bottom: 64px;
      }
    `}
`;
const alertTime = tinytime("{Mo}/{DD}/{YYYY}");
const PostPagePageBanner = (props)=>{
    const { item , isRootTopicForPostType , negativeMargins  } = props;
    const { archivedAt , isExplicitlyArchived , deletedAt , isExplicitlyDeleted , type ,  } = item;
    let itemType = "leaf";
    const postParent = isRootTopicForPostType ? "tree" : "branch";
    let implicitArchiveText = `This ${itemType} is in an archived ${postParent}`;
    let implicitDeleteText = `This ${itemType} is in a ${postParent} marked for deletion`;
    if (type === ItemType.Checklist) {
        itemType = "to-do list";
        implicitArchiveText = "This is part of an archived leaf";
        implicitDeleteText = "This is part of a leaf marked for deletion";
    } else if (type === ItemType.ChecklistItem) {
        itemType = "todo";
        implicitArchiveText = "This is part of an archived to-do list";
        implicitDeleteText = "This is part of a to-do list marked for deletion";
    }
    const { authorized  } = usePostPage();
    const canUnarchive = authorized && !deletedAt;
    const setItemsArchived = useSetItemsArchived();
    const unarchiveItem = useCallback(()=>{
        setItemsArchived({
            items: [
                item
            ],
            isExplicitlyArchived: false
        });
    }, [
        setItemsArchived,
        item
    ]);
    const canRestore = authorized;
    const setItemsDeleted = useSetItemsDeleted();
    const restoreTopic = useCallback(()=>{
        setItemsDeleted({
            items: [
                item
            ],
            isExplicitlyDeleted: false
        });
    }, [
        item,
        setItemsDeleted
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            archivedAt && !deletedAt && /*#__PURE__*/ _jsxs(PageBannerWrapper, {
                bg: "yellow.100",
                $negativeMargins: negativeMargins,
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        lineHeight: "24px",
                        textAlign: "center",
                        children: isExplicitlyArchived ? `This ${itemType} was archived on ${alertTime.render(new Date(archivedAt))}` : implicitArchiveText
                    }),
                    isExplicitlyArchived && canUnarchive && /*#__PURE__*/ _jsx(Button, {
                        variant: "outline",
                        color: "primary",
                        onClick: unarchiveItem,
                        children: "Unarchive"
                    })
                ]
            }),
            deletedAt && /*#__PURE__*/ _jsxs(PageBannerWrapper, {
                bg: "grey.200",
                $negativeMargins: negativeMargins,
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        lineHeight: "24px",
                        textAlign: "center",
                        children: isExplicitlyDeleted ? `This ${itemType} was put in the trash on ${alertTime.render(new Date(deletedAt))}` : implicitDeleteText
                    }),
                    isExplicitlyDeleted && canRestore && /*#__PURE__*/ _jsx(Button, {
                        variant: "outline",
                        color: "primary",
                        onClick: restoreTopic,
                        children: "Restore"
                    })
                ]
            })
        ]
    });
};
export default PostPagePageBanner;
